var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPocketPathologistIconPricingTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    enableBackground: "new 0 0 700 700",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#98D0D7",
    d: "M466.38,134.29H332.22H202.48h-24.15c-18.6,0-33.68,15.08-33.68,33.68v10.94c0,7.3,5.91,13.21,13.21,13.21 h44.62v330.29c0,18.18,14.74,32.92,32.92,32.92h263.36V166.67C498.76,148.79,484.26,134.29,466.38,134.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A5AE",
    d: "M202.48,158.44v33.68h-45.26c-6.94,0-12.56-5.63-12.56-12.56v-11.58c0-5.23,1.19-10.18,3.32-14.6 c5.44-11.29,16.99-19.08,30.36-19.08c6.67,0,12.7,2.7,17.07,7.07C199.77,145.74,202.48,151.77,202.48,158.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E1E6",
    d: "M511.76,498.15v57.18H246.23c18.18,0,32.92-14.74,32.92-32.92v-3.97c0-11.2,9.08-20.29,20.29-20.29H511.76 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A5AE",
    d: "M571.53,492.08c0,18.14-6.63,34.72-17.61,47.46c-13.34,15.5-33.11,25.31-55.16,25.31 c-40.19,0-72.77-32.58-72.77-72.77c0-11.43,2.64-22.25,7.33-31.87c3.63-7.44,8.5-14.17,14.32-19.92l0,0 c13.14-12.97,31.19-20.97,51.11-20.97C538.95,419.31,571.53,451.89,571.53,492.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C899B",
    d: "M202.48,158.44v33.68h-15.4c0.49-10.32-0.01-28.59-8.42-37.9c-8.01-8.87-22.06-4.7-30.68-0.85 c5.44-11.29,16.99-19.08,30.36-19.08c6.67,0,12.7,2.7,17.07,7.07C199.77,145.74,202.48,151.77,202.48,158.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E1E6",
    d: "M282.88,219.19h-30.11c-6.82,0-12.35-5.53-12.35-12.35v-30.11c0-6.82,5.53-12.35,12.35-12.35h30.11 c6.82,0,12.35,5.53,12.35,12.35v30.11C295.23,213.67,289.7,219.19,282.88,219.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E1E6",
    d: "M282.88,302h-30.11c-6.82,0-12.35-5.53-12.35-12.35v-30.11c0-6.82,5.53-12.35,12.35-12.35h30.11 c6.82,0,12.35,5.53,12.35,12.35v30.11C295.23,296.47,289.7,302,282.88,302z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E1E6",
    d: "M282.88,384.8h-30.11c-6.82,0-12.35-5.53-12.35-12.35v-30.11c0-6.82,5.53-12.35,12.35-12.35h30.11 c6.82,0,12.35,5.53,12.35,12.35v30.11C295.23,379.27,289.7,384.8,282.88,384.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E1E6",
    d: "M282.88,467.6h-30.11c-6.82,0-12.35-5.53-12.35-12.35v-30.11c0-6.82,5.53-12.35,12.35-12.35h30.11 c6.82,0,12.35,5.53,12.35,12.35v30.11C295.23,462.08,289.7,467.6,282.88,467.6z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 8.5429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 315.97,
    y1: 178.48,
    x2: 464.11,
    y2: 178.48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 8.5429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 315.97,
    y1: 207.93,
    x2: 378.99,
    y2: 207.93
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 8.5429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 405.2,
    y1: 207.93,
    x2: 464.11,
    y2: 207.93
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 8.5429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 315.97,
    y1: 259.91,
    x2: 464.11,
    y2: 259.91
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 8.5429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 315.97,
    y1: 289.36,
    x2: 418.19,
    y2: 289.36
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 8.5429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 315.97,
    y1: 343.1,
    x2: 457.18,
    y2: 343.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 8.5429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 315.97,
    y1: 369.96,
    x2: 344.56,
    y2: 369.96
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 8.5429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 372.28,
    y1: 369.96,
    x2: 457.18,
    y2: 369.96
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 8.5429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 315.97,
    y1: 427.43,
    x2: 372.28,
    y2: 427.43
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 8.5429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 395.67,
    y1: 427.43,
    x2: 447.65,
    y2: 427.43
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 8.5429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 315.97,
    y1: 454.29,
    x2: 414.73,
    y2: 454.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 17.0858,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M501.71,493.31H493c-8.66,0-15.68-6.04-15.68-13.5v0c0-7.46,7.02-13.5,15.68-13.5h7.03h13.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 17.0858,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M481.61,520.32h25.46c8.66,0,15.68-6.04,15.68-13.5v0c0-7.46-7.02-13.5-15.68-13.5h-8.71"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 17.0858,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 499.17,
    y1: 452.02,
    x2: 499.17,
    y2: 466.31
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 17.0858,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 500.04,
    y1: 520.32,
    x2: 500.04,
    y2: 532.15
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0C899B",
    d: "M553.92,539.55c-13.34,15.5-33.11,25.31-55.16,25.31c-40.19,0-72.77-32.58-72.77-72.77 c0-11.43,2.64-22.25,7.33-31.87c4.16-6.32,8.92-12.95,14.32-19.91c-0.45,0.99-23.96,100.3,41.37,113.51 C520.37,560.15,540.63,552.6,553.92,539.55z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketPathologistIconPricingTransparent);
export default __webpack_public_path__ + "static/media/Pocket Pathologist-Icon_Pricing-transparent.5837204e1a61f33b921507f128c31c36.svg";
export { ForwardRef as ReactComponent };